// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"link-button_linkButton__2OabC"};